enum Density {

  DEFAULT = 'default',
  CONFORTABLE = 'confortable',
  COMPACT = 'compact',

  TOUCH = 'touch',
  REGULAR = 'regular',
  DENSE = 'dense',
}

export default Density;
